export var TimeFormatsConstants = {
    TWELVE_HOUR: 'h:mm a',
    TWELVE_HOUR_NO_MERIDIAN: 'h:mm',
    TWENTY_FOUR_HOUR: 'HH:mm',
};
/* @TODO Update this to be lowercase */
export var ComposerMode = {
    CREATE: 'create',
    EDIT: 'edit',
};
/**
 * Abstract buffer event types used by the shared EventComposer component.
 * These are mapped to app-specific Amplitude event names at the application level.
 */
export var BufferEventType = {
    ADDED_BUFFER: 'addBuffer',
    REMOVED_BUFFER: 'removeBuffer',
    CREATED_BUFFER_EVENT: 'createdBufferEvent',
    DETECTED_BUFFER_CONFLICT: 'detectedBufferConflict',
};
/**
 * Container the EventComposer renders itself inside.
 *
 * - `drawer` (default): wraps the body in an Ant Design `Drawer`. This
 *   matches the legacy behavior — the Drawer portals to document.body and
 *   floats above the page.
 * - `inline`: renders the body inline with its own header (title + close
 *   button), with no portal. Use this when you want to host the composer
 *   inside your own layout primitive (e.g. the shell's right-hand `Sider`),
 *   so the composer occupies the layout slot rather than floating over it.
 */
export var ComposerContainerMode = {
    DRAWER: 'drawer',
    INLINE: 'inline',
};
